import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Link2, Loader2, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { API, TIPI_PROBLEMA, IMPIANTI } from "@/lib/config";
import { RichiediRecensione } from "./RichiediRecensione";

const VUOTO = { nome: "", telefono: "", email: "", tipo_problema: "", impianto: "civile" };

export const NuovoLinkRecensione = ({ pwd }) => {
  const [f, setF] = useState(VUOTO);
  const [loading, setLoading] = useState(false);
  const [creato, setCreato] = useState(null);
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v?.target ? v.target.value : v }));

  const crea = async (e) => {
    e.preventDefault();
    if (!f.tipo_problema) return toast.error("Scegli il tipo di intervento");
    setLoading(true);
    try {
      const r = await axios.post(`${API}/admin/link-recensione`, f, { headers: { "X-Admin-Password": pwd } });
      setCreato(r.data); setF(VUOTO);
      toast.success("Link recensione creato");
    } catch { toast.error("Controlla nome e telefono (minimo 6 cifre)"); } finally { setLoading(false); }
  };

  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-5 sm:p-6 space-y-4" data-testid="nuovo-link-recensione">
      <div>
        <h2 className="flex items-center gap-2 text-lg font-bold"><Link2 className="w-5 h-5 text-sky-600" /> Crea un link per recensire un intervento</h2>
        <p className="text-sm text-slate-500 mt-1">Per i clienti già serviti che non hanno usato il modulo del sito. Il link vale per una sola recensione verificata.</p>
      </div>
      <form onSubmit={crea} className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3" data-testid="nuovo-link-form">
        <Input required minLength={2} value={f.nome} onChange={set("nome")} placeholder="Nome cliente" className="h-11" data-testid="link-nome-input" />
        <Input required minLength={6} type="tel" value={f.telefono} onChange={set("telefono")} placeholder="Telefono" className="h-11" data-testid="link-telefono-input" />
        <Input type="email" value={f.email} onChange={set("email")} placeholder="Email (facoltativa)" className="h-11" data-testid="link-email-input" />
        <Select value={f.tipo_problema} onValueChange={set("tipo_problema")}>
          <SelectTrigger className="h-11" data-testid="link-tipo-select"><SelectValue placeholder="Tipo intervento" /></SelectTrigger>
          <SelectContent>{TIPI_PROBLEMA.map((t, i) => <SelectItem key={t} value={t} data-testid={`link-tipo-option-${i}`}>{t}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={f.impianto} onValueChange={set("impianto")}>
          <SelectTrigger className="h-11" data-testid="link-impianto-select"><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(IMPIANTI).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
        </Select>
        <button disabled={loading} className="sm:col-span-2 lg:col-span-5 justify-self-start inline-flex items-center gap-2 h-11 px-6 rounded-full bg-sky-600 text-white text-sm font-bold hover:bg-sky-700 disabled:opacity-60" data-testid="link-crea-btn">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />} Crea link
        </button>
      </form>
      {creato && (
        <div className="space-y-2" data-testid="link-creato">
          <p className="text-sm">Link per <b>{creato.nome}</b>: <span className="font-mono text-xs break-all text-sky-700" data-testid="link-creato-url">{`${window.location.origin}/recensione/${creato.review_token}`}</span></p>
          <RichiediRecensione it={creato} />
        </div>
      )}
    </div>
  );
};
